import produce from 'immer';
import * as types from './actionTypes';

const INITIAL_STATE = {
  areas: [],
  currentArea: null,
  loading: false,
  loadingForm: false,
  error: null,
  success: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    pages: 0
  },
  filters: {
    idEmpresa: [],
    nome_area: '',
    disponivel: 'todos'
  }
};

export default function areasArmazenamentoReducer(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      // ========== LISTAR ==========
      case types.FETCH_AREAS_REQUEST:
        draft.loading = true;
        draft.error = null;
        break;

      case types.FETCH_AREAS_SUCCESS:
        draft.loading = false;
        draft.areas = action.payload.data;
        draft.error = null;
        break;

      case types.FETCH_AREAS_FAILURE:
        draft.loading = false;
        draft.error = action.payload.error;
        break;

      // ========== BUSCAR POR ID ==========
      case types.FETCH_AREA_BY_ID_REQUEST:
        draft.loadingForm = true;
        draft.error = null;
        draft.currentArea = null;
        break;

      case types.FETCH_AREA_BY_ID_SUCCESS:
        draft.loadingForm = false;
        draft.currentArea = action.payload.data;
        draft.error = null;
        break;

      case types.FETCH_AREA_BY_ID_FAILURE:
        draft.loadingForm = false;
        draft.error = action.payload.error;
        break;

      // ========== CRIAR ==========
      case types.CREATE_AREA_REQUEST:
        draft.loadingForm = true;
        draft.error = null;
        break;

      case types.CREATE_AREA_SUCCESS:
        draft.loadingForm = false;
        draft.error = null;
        break;

      case types.CREATE_AREA_FAILURE:
        draft.loadingForm = false;
        draft.error = action.payload.error;
        break;

      // ========== ATUALIZAR ==========
      case types.UPDATE_AREA_REQUEST:
        draft.loadingForm = true;
        draft.error = null;
        break;

      case types.UPDATE_AREA_SUCCESS:
        draft.loadingForm = false;
        draft.currentArea = action.payload.data;
        draft.error = null;
        break;

      case types.UPDATE_AREA_FAILURE:
        draft.loadingForm = false;
        draft.error = action.payload.error;
        break;

      // ========== REMOVER ==========
      case types.DELETE_AREA_REQUEST:
        draft.loading = true;
        draft.error = null;
        break;

      case types.DELETE_AREA_SUCCESS:
        draft.loading = false;
        draft.areas = draft.areas.filter(area => area.id !== action.payload.id);
        draft.error = null;
        break;

      case types.DELETE_AREA_FAILURE:
        draft.loading = false;
        draft.error = action.payload.error;
        draft.success = null;
        break;

      // ========== DUPLICAR ==========
      case types.DUPLICATE_AREA_REQUEST:
        draft.loading = true;
        draft.error = null;
        break;

      case types.DUPLICATE_AREA_SUCCESS:
        draft.loading = false;
        draft.error = null;
        break;

      case types.DUPLICATE_AREA_FAILURE:
        draft.loading = false;
        draft.error = action.payload.error;
        break;

      // ========== UTILITÁRIOS ==========
      case types.CLEAR_AREA_FORM:
        draft.currentArea = null;
        draft.loadingForm = false;
        draft.error = null;
        break;

      case types.CLEAR_MESSAGES:
        draft.error = null;
        break;

      case types.SET_FILTERS:
        draft.filters = { ...draft.filters, ...action.payload.filters };
        break;

      case types.CLEAR_FILTERS:
        draft.filters = INITIAL_STATE.filters;
        break;

      default:
        return state;
    }
  });
}